var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTransactions = function SvgTransactions(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1388 26.8398C9.92335 26.8819 9.70437 26.9032 9.48486 26.9035H10.1388V26.8398Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1403 26.8982H22.9178C22.2583 26.8755 21.634 26.5947 21.1795 26.1163C20.7249 25.6378 20.4763 25 20.4873 24.3401V19.1662C20.4873 19.1049 20.4752 19.0442 20.4516 18.9876C20.4279 18.9311 20.3933 18.8798 20.3497 18.8367C20.3061 18.7936 20.2544 18.7597 20.1975 18.7367C20.1407 18.7138 20.0799 18.7024 20.0186 18.7032H6.47722C6.4167 18.7032 6.35677 18.7152 6.30092 18.7385C6.24508 18.7618 6.19442 18.796 6.15189 18.8391C6.10937 18.8822 6.07581 18.9333 6.05318 18.9894C6.03055 19.0456 6.01929 19.1056 6.02006 19.1662V23.4257C6.02006 24.3467 6.38587 25.2299 7.03702 25.8811C7.68818 26.5323 8.57133 26.8982 9.4922 26.8982H10.1403Z",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1401 18.7035V14.8086",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1401 4.79081V2.99671C10.14 2.8481 10.1969 2.70512 10.2993 2.59738C10.4016 2.48964 10.5415 2.4254 10.6899 2.41797H25.8516C26.0051 2.41797 26.1523 2.47894 26.2608 2.58748C26.3693 2.69601 26.4303 2.84322 26.4303 2.99671V23.4263C26.4303 24.3473 26.0645 25.2305 25.4133 25.8817C24.7622 26.5329 23.879 26.8988 22.9582 26.8988V26.8988C22.2986 26.8761 21.6743 26.5953 21.2198 26.1169C20.7652 25.6385 20.5166 25.0006 20.5276 24.3407",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Transactions.6205facc.svg";
export { ForwardRef as ReactComponent };